/* Keep lazy media working when Shopify replaces a section in the editor. */
if (!customElements.get('solstice-signature-card')) {
  customElements.define('solstice-signature-card', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      const {signal} = this.abort;
      const videos = [...this.querySelectorAll('video.simple-signature-video')];
      const visible = new Set();
      const play = video => {
        if (!this.isConnected || !visible.has(video) || document.hidden ||
            document.body.classList.contains('ear-app-is-open') || document.documentElement.classList.contains('ear-force-loading-app')) {
          video.pause();
          return;
        }
        if (!video.getClientRects().length) return;
        video.muted = true;
        video.play()?.catch(() => {});
      };
      const load = video => {
        if (!visible.has(video) || document.hidden || document.body.classList.contains('ear-app-is-open') ||
            document.documentElement.classList.contains('ear-force-loading-app')) { video.pause(); return; }
        if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
        if (video.dataset.src && !video.getAttribute('src')) {
          video.src = video.dataset.src;
          video.load();
        }
        video.classList.remove('lazy-video-simple');
        play(video);
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) { visible.add(entry.target); load(entry.target); }
            else { visible.delete(entry.target); entry.target.pause(); }
          });
        });
        videos.forEach(video => this.observer.observe(video));
      } else videos.forEach(video => {visible.add(video);load(video);});
      const resume = () => {
        videos.forEach(video => visible.has(video) ? load(video) : video.pause());
      };
      videos.forEach(video => video.addEventListener('canplay', () => play(video), {signal}));
      document.addEventListener('visibilitychange', resume, {signal});
      window.addEventListener('pageshow', resume, {signal});
      window.addEventListener('focus', resume, {signal});
      window.addEventListener('vue-toggle-app', event => {
        if (event.detail === true) videos.forEach(video => video.pause());
        else requestAnimationFrame(resume);
      }, {signal});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
